import {
  MEMBER_ACTIONS,
  MEMBER_DOWNLOAD_ACTIONS,
  MEMBER_TRANSACTION_ACTIONS,
  MEMBER_SEARCH_ACTIONS
} from '../../constants/actions'

const getMembers = (payload) => {
  return {
    type: MEMBER_ACTIONS.ON_GET_MEMBERS,
    payload
  }
}

const getMembersForDownload = () => {
  return {
    type: MEMBER_DOWNLOAD_ACTIONS.ON_GET_MEMBERS_FOR_DOWNLOAD
  }
}

const resetMembersDownloadState = () => {
  return {
    type: MEMBER_DOWNLOAD_ACTIONS.ON_RESET_STATE
  }
}

const resetMembersState = () => {
  return {
    type: MEMBER_ACTIONS.ON_RESET_STATE
  }
}

// MEMBER TRANSACTION
const changeMemberTransactionState = (property, value) => {
  return {
    type: MEMBER_TRANSACTION_ACTIONS.ON_CHANGE_STATE,
    payload: {
      property,
      value
    }
  }
}

const resetMemberTransactionState = () => {
  return {
    type: MEMBER_TRANSACTION_ACTIONS.ON_RESET_STATE
  }
}

const memberTransaction = () => {
  return {
    type: MEMBER_TRANSACTION_ACTIONS.ON_CREDIT_DEBIT_POINTS
  }
}

const getMemberBalances = () => {
  return {
    type: MEMBER_TRANSACTION_ACTIONS.ON_GET_BALANCES
  }
}

const getMemberTransactions = () => {
  return {
    type: MEMBER_ACTIONS.ON_GET_RECENT_TRANSACTIONS
  }
}

// MEMBER SEARCH
const changeMemberSearchState = (property, value) => {
  return {
    type: MEMBER_SEARCH_ACTIONS.ON_CHANGE_STATE,
    payload: {
      property,
      value
    }
  }
}

const resetMemberSearchState = () => {
  return {
    type: MEMBER_SEARCH_ACTIONS.ON_RESET_STATE
  }
}

const searchMembers = (query) => {
  return {
    type: MEMBER_SEARCH_ACTIONS.ON_SEARCH,
    payload: { query }
  }
}

export {
  getMembers,
  getMembersForDownload,
  resetMembersDownloadState,
  resetMembersState,
  changeMemberTransactionState,
  resetMemberTransactionState,
  memberTransaction,
  getMemberBalances,
  changeMemberSearchState,
  resetMemberSearchState,
  searchMembers,
  getMemberTransactions
}
